// extracted by mini-css-extract-plugin
export default {"root":"ApplicationInaccessible_root__NGlHc","img":"ApplicationInaccessible_img__NXzJ+","h1":"ApplicationInaccessible_h1__BfKub","p":"ApplicationInaccessible_p__eZQwk"};